// Constant for SkeletonLoader

export const THEME = {
  LIGHT : 'light',
  DARK  : 'dark'
}
